import { PremiumPurchasePlatformModule } from '@wix/premium-purchase-platform/@sdk';
import { ECLIPSE_LIGHT_PRODUCT_FAMILY_ID, isDropshippingFlow } from '@wix/package-picker-shared';
import { EclipseOfferingApiClientContext } from '../eclipse-offering.context';
export const fetchOfferingQueryFn = async props => {
  const {
    httpClient
  } = props;
  const {
    getPurchaseUserOffering
  } = PremiumPurchasePlatformModule.SDK.ApiClient.queries({
    httpClient
  });
  const p3Context = EclipseOfferingApiClientContext.get('p3Context');
  if (!p3Context) {
    throw new Error('P3 context is required to fetch offering');
  }
  const offeringData = await getPurchaseUserOffering({
    ...p3Context
  });
  const isDropshippingIntent = isDropshippingFlow();
  if (isDropshippingIntent && offeringData.products) {
    offeringData.products = offeringData.products.filter(product => product.productFamilyId !== ECLIPSE_LIGHT_PRODUCT_FAMILY_ID);
  }
  return offeringData;
};
//# sourceMappingURL=fetch-offering.query.js.map